module.exports = __webpack_public_path__ + "media/images/redrock/powder-ecfa3cae8207c9cc948ada2e0ae80468.jpg";